export type PodcastPlatformId =
  | "apple_podcasts"
  | "spotify"
  | "youtube"
  | "amazon_music";

export const PODCAST_PLATFORM_LABEL: Record<PodcastPlatformId, string> = {
  apple_podcasts: "Apple Podcasts",
  spotify: "Spotify",
  youtube: "YouTube",
  amazon_music: "Amazon Music",
};

export function PodcastPlatformIcon({
  id,
  className,
}: {
  id: PodcastPlatformId;
  className?: string;
}) {
  const common = {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    className: className ?? "size-4",
    "aria-hidden": true as const,
  };

  switch (id) {
    case "spotify":
      return (
        <svg {...common}>
          <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.559.3z" />
        </svg>
      );
    case "apple_podcasts":
      return (
        <svg {...common}>
          <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 4.32c2.621 0 4.748 2.127 4.748 4.748 0 1.355-.572 2.578-1.485 3.444 1.918 1.022 3.252 3.011 3.252 5.31 0 .413-.04.811-.13 1.193h-1.39c.097-.378.146-.78.146-1.193 0-2.828-2.297-5.124-5.124-5.124-2.828 0-5.124 2.296-5.124 5.124 0 .413.048.815.146 1.193h-1.39c-.09-.382-.13-.78-.13-1.193 0-2.299 1.334-4.288 3.252-5.31-.913-.866-1.485-2.089-1.485-3.444C7.252 6.447 9.379 4.32 12 4.32zm0 1.392c-1.854 0-3.356 1.502-3.356 3.356 0 1.854 1.502 3.356 3.356 3.356s3.356-1.502 3.356-3.356c0-1.854-1.502-3.356-3.356-3.356zM12 15.276c1.32 0 2.39 1.07 2.39 2.391 0 .82-.413 1.546-1.043 1.978l-.4 2.965a.96.96 0 0 1-.952.839h-.001a.96.96 0 0 1-.951-.84l-.4-2.964a2.388 2.388 0 0 1-1.043-1.978c0-1.32 1.07-2.391 2.4-2.391z" />
        </svg>
      );
    case "youtube":
      return (
        <svg {...common}>
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
        </svg>
      );
    case "amazon_music":
      return (
        <svg {...common}>
          <path d="M22.4 0H1.6A1.6 1.6 0 0 0 0 1.6v20.8A1.6 1.6 0 0 0 1.6 24h20.8a1.6 1.6 0 0 0 1.6-1.6V1.6A1.6 1.6 0 0 0 22.4 0zM18.4 18.34c-1.7 1.25-4.17 1.92-6.28 1.92a11.36 11.36 0 0 1-7.67-2.93c-.16-.14-.02-.34.18-.23a15.43 15.43 0 0 0 7.67 2.04 15.3 15.3 0 0 0 5.85-1.2c.3-.13.55.2.25.4zm.71-.81c-.21-.27-1.42-.13-1.96-.06-.16.02-.19-.12-.04-.23.96-.68 2.54-.48 2.72-.25.18.23-.05 1.81-.95 2.56-.14.11-.27.05-.21-.1.2-.51.66-1.65.44-1.92zM4.06 8.06h1.74v8.65H4.06zm.87-1.31a1.01 1.01 0 1 1 0-2.02 1.01 1.01 0 0 1 0 2.02zM12 8.06c2.07 0 3.6 1.27 3.6 3.92v4.73h-1.74v-4.5c0-1.61-.69-2.42-1.99-2.42-1.27 0-2.07.79-2.07 2.42v4.5H8.06V8.06h1.74v1.04C10.34 8.4 11.07 8.06 12 8.06zm6.94 0h1.74v8.65h-1.74z" />
        </svg>
      );
  }
}
